const TitleBiblioDescriptionsEnum = {
	summary: {
		LocalizeId: 'desc_summary',
	},
	authorBio: {
		LocalizeId: 'tb_author_bio',
	},
	marketingPlans: {
		LocalizeId: 'marketing_plans',
	},
	keySellingPoints: {
		LocalizeId: 'key_selling_points',
	},
	quotes: {
		LocalizeId: 'quotes',
	},
};

export default TitleBiblioDescriptionsEnum;
